<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{ data.title }}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <form [formGroup]="elementForm" class="col-12">
            <!-- Hidden Inputs for ID -->
            <input matInput [formControlName]="'id'" hidden>
            <input matInput [formControlName]="'elementId'" hidden>
            
            <!-- Name Field -->
            <div class="row p-0">
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline">
                        <mat-label>Name</mat-label>
                        <input matInput formControlName="name" placeholder="Enter name" required>
                        <mat-error *ngIf="elementForm.get('name')?.hasError('required')">
                            Name is required.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Type Dropdown -->
            <div class="row p-0">
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline">
                        <mat-label>Type</mat-label>
                        <mat-select formControlName="type" required>
                            <mat-option *ngFor="let item of type" [value]="item.value">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="elementForm.get('type')?.hasError('required')">
                            Type is required.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-6 input-box">
                    <mat-form-field appearance="outline">
                        <mat-label>Sign</mat-label>
                        <mat-select formControlName="sign" required>
                            <mat-option *ngFor="let item of sign" [value]="item.value">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="elementForm.get('sign')?.hasError('required')">
                            Sign is required.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <!-- Checkboxes for Various Options -->
            <div class="row mt-3">
                <div class="col-6">
                    <mat-checkbox formControlName="summaryLevel">
                        Summary Level
                    </mat-checkbox>
                </div>
            </div>

            <div class="row mt-1" *ngIf="!elementForm.get('summaryLevel')?.value">
                <div class="col-6">
                    <mat-checkbox formControlName="docControlled">
                        Document Controlled
                    </mat-checkbox>
                </div>
                <div class="col-6">
                    <mat-checkbox formControlName="postActual">
                        Post Actual
                    </mat-checkbox>
                </div>
            </div>

            <div class="row mt-1" *ngIf="!elementForm.get('summaryLevel')?.value">
                <div class="col-6">
                    <mat-checkbox formControlName="manageBP">
                        Manage BP
                    </mat-checkbox>
                </div>
                <div class="col-6">
                    <mat-checkbox formControlName="postBudget">
                        Post Budget
                    </mat-checkbox>
                </div>
            </div>

            <div class="row mt-1" *ngIf="!elementForm.get('summaryLevel')?.value">
                <div class="col-6">
                    <mat-checkbox formControlName="bankAccount">
                        Bank Account
                    </mat-checkbox>
                </div>
                <div class="col-6">
                    <mat-checkbox formControlName="manageProd">
                        Manage Product
                    </mat-checkbox>
                </div>
            </div>

            <div class="row mt-1" *ngIf="!elementForm.get('summaryLevel')?.value">
                <div class="col-6">
                    <mat-checkbox formControlName="postStatistical">
                        Post Statistical
                    </mat-checkbox>
                </div>
            </div>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <button mat-button class="btn btn-success yes-button" [disabled]="elementForm.invalid" (click)="save()"
            *ngIf="!isLoading; else loadingTemplate" cdkFocusInitial>{{data.confirmText}}</button>
        <ng-template #loadingTemplate>
            <button mat-button class="btn btn-success yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>